import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreCustomersByIdFeatureFlagsGetSlice } from './get';

export const coreCustomersByIdFeatureFlagsReducers = combineReducers({
	get: coreCustomersByIdFeatureFlagsGetSlice.asyncReducers
});

export const coreCustomersByIdFeatureFlagsWatchers = combineAllWatchers([
	coreCustomersByIdFeatureFlagsGetSlice.asyncWatchers
]);
